"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullWidthLink = exports.InfoStack = exports.ItemStack = exports.ArticleImage = exports.Title = exports.WrapInner = exports.Wrap = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.Wrap = (0, app_1.styled)(ui_1.Stack) `
  --wrap-size: 31.25rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  padding: calc(${(theme) => theme.spacing.extraLarge} * 2)
    ${(theme) => theme.spacing.extraLarge};
  @media ${app_1.notDesktop} {
    padding: calc(${(theme) => theme.spacing.small} * 2)
      ${(theme) => theme.spacing.small};
  }

  @media ${app_1.notDesktop} {
    --wrap-size: 15rem;
  }
`;
exports.WrapInner = app_1.styled.div `
  position: relative;
  padding-left: 3rem;
  width: 100%;
`;
exports.Title = (0, app_1.styled)(app_1.Text) `
  max-width: var(--wrap-size);
`;
exports.ArticleImage = app_1.styled.div `
  height: var(--wrap-size);
  width: 40rem;
  @media ${app_1.notDesktop} {
    width: 20rem;
  }
`;
exports.ItemStack = (0, app_1.styled)(ui_1.Stack) `
  height: 100%;
  text-align: left;
`;
exports.InfoStack = (0, app_1.styled)(ui_1.Stack) `
  position: absolute;
  top: var(--wrap-size);
  width: var(--wrap-size);
  left: 0;
  transform: rotate(-90deg);
  transform-origin: 0 0;
`;
exports.FullWidthLink = (0, app_1.styled)(app_1.Link) `
  height: 100%;
  width: 40rem;

  @media ${app_1.notDesktop} {
    width: 20rem;
  }
`;
